import { Link } from "react-router-dom";
import { useLang } from "@/i18n";

export function LegalLinks({ className = "" }) {
  const { t } = useLang();
  return (
    <span className={`inline-flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-vox-dim ${className}`} data-testid="legal-links">
      <Link to="/legal/privacy" className="hover:text-vox-text" data-testid="legal-link-privacy">{t("legal.privacy")}</Link>
      <span className="text-vox-line">·</span>
      <Link to="/legal/terms" className="hover:text-vox-text" data-testid="legal-link-terms">{t("legal.terms")}</Link>
    </span>
  );
}
